import { createContext, useContext, useState } from "react";
import type { IChartDataAll } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/types";
import { EMetricType } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/types";
import type { IData } from "app/pages/website-analysis/audience-overlap/SharedVisitorsTable/sharedTypes";
import { allTrackers } from "app/services/track/track";

export interface IOverlapOvertimeContext {
    selectedMetric: EMetricType;
    setSelectedMetric: (selectedMetric: EMetricType) => void;
    rawData: IData;
    chartDataAll: IChartDataAll;
    setChartDataAll: (chartDataAll: IChartDataAll) => void;
}

export const OverlapOvertimeContext = createContext<IOverlapOvertimeContext>(null);

export const useOverlapOvertimeContext = (): IOverlapOvertimeContext => useContext(OverlapOvertimeContext);

export const getInitialValue = (rawData: IData): IOverlapOvertimeContext => {
    const initialState = {
        selectedMetric: EMetricType.TOTAL,
        rawData,
        chartDataAll: null,
    };
    const [state, setState] = useState(initialState);
    return {
        ...state,
        setSelectedMetric: (selectedMetric) => {
            allTrackers.trackEvent(
                "Metric Button",
                "click",
                `overlapOvertime/Change Metric/${EMetricType[selectedMetric]}`,
            );
            setState({
                ...state,
                selectedMetric,
            });
        },
        setChartDataAll: (chartDataAll) => {
            setState({
                ...state,
                chartDataAll,
            });
        },
    };
};
